module.exports = __webpack_public_path__ + "static/media/layout4-img.ba4bb6a7.svg";